import React from 'react'

import File from './File'
import Input from './Input'
import Radio from './Radio'
import Select from './Select'
import TextArea from './TextArea'


const FormControl = (props) => {
    const {control, ...rest} = props
    switch(control) {
        case 'input':
            return <Input {...rest}/>
        case 'file':
            return <File {...rest}/>
        case 'textarea':
            return <TextArea {...rest}/>
        case 'select':
            return <Select {...rest}/>
        case 'radio':
            return <Radio {...rest}/>


            
        default: return null
    }
}

export default FormControl
